import postProcessSuggestionsResult from './postProcessSuggestionsResult';
import setFindResultSet from '../setFindResultSet';
import setIsSearching from '../setIsSearching';
import removeDuplicateResultsFromCacheResults from '../../utils/removeDuplicateResultsFromCacheResults';
import { FindResultType } from 'owa-recipient-types/lib/types/FindControlViewState';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import addLocalCacheTransactionComplete from 'owa-recipient-common/lib/utils/addLocalCacheTransactionComplete';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import { action } from 'satcheljs/lib/legacy';

const MAX_RESULTS = 5;

export default action('processCacheResult')(async function processCacheResult(
    recipientWell: FindControlViewState | RecipientWellWithFindControlViewState,
    cacheResults: PersonaType[],
    appendResults: boolean,
    resolveIfSingle: boolean
): Promise<void> {
    if (appendResults) {
        const currentResultsMap = new Map<string, FindRecipientPersonaType>();
        recipientWell.findResultSet.forEach(value => {
            currentResultsMap[value.EmailAddress.EmailAddress] = value;
        });
        cacheResults = removeDuplicateResultsFromCacheResults(currentResultsMap, cacheResults);

        cacheResults = [...recipientWell.findResultSet, ...cacheResults];
        cacheResults.splice(MAX_RESULTS);
    }

    setIsSearching(recipientWell, false);
    setFindResultSet(recipientWell, cacheResults as FindRecipientPersonaType[]);
    addLocalCacheTransactionComplete(recipientWell);
    postProcessSuggestionsResult(recipientWell, FindResultType.Cache, resolveIfSingle);
});
